import { isEqual } from "@epcnetwork/core-ui-kit";

export const findKeyByValue = <T extends Record<string, any>>(
  obj: T,
  value: T[keyof T],
): keyof T | undefined => Object.keys(obj).find((key) => isEqual(obj[key], value));
